import { PropsWithChildren, SyntheticEvent, useRef } from 'react'
import { MenuItem } from 'primereact/menuitem'
import { Menu } from 'primereact/menu'
import { Button } from 'primereact/button'

import { Row } from './pure/FlexContainer'
import { pi } from './pure/PrimeIcon'

interface ScreenHeaderProps extends PropsWithChildren {
    menu?: MenuItem[]
}
export default function ContextHeader({ menu, children }: ScreenHeaderProps) {
    const ref = useRef<Menu>(null)
    const toggle = (event: SyntheticEvent) => ref.current?.toggle(event)
    const hasMenu = menu && menu.length > 0
    return (
        <Row gap={2} arrangement="start" alignment="center">
            {children}
            {hasMenu && (
                <>
                    <Button
                        style={{ border: 'none' }}
                        onClick={toggle}
                        icon={pi('ellipsis-v')}
                        rounded
                        outlined
                        severity="secondary"
                    />
                    <Menu ref={ref} model={menu} popup />
                </>
            )}
        </Row>
    )
}
